<template>
  <div class="banner-swiper">

    <swiper :options="swiperOption" class="banner-swiper-block">
      <swiper-slide v-for="(item, index) in swiperList" :key="index">
        <div class="banner-swiper-item">
          <i class="banner-swiper-item-bg" :style="itemBgStyle(item.bg)"></i>
          <div class="banner-swiper-item-wrap">
            <p class="banner-swiper-item-title">{{item.title}}</p>
            <p class="banner-swiper-item-desc">{{item.desc}}</p>
            <ul class="banner-swiper-item-box">
              <li class="banner-swiper-item-content" v-for="(content, contentIndex) in item.contentList"
                  :key="contentIndex">
                <div class="banner-swiper-item-icon">
                  <img :src="content.icon" alt="">
                </div>
                <p class="banner-swiper-item-content-title">{{content.title}}</p>
                <p class="banner-swiper-item-content-desc" v-html="content.desc"></p>
              </li>
            </ul>
            <a href="javascript:" class="banner-swiper-item-btn" v-if="item.btn" @click="onClickBtn(item)">{{item.btn.title}}</a>
          </div>
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
      <div class="banner-swiper-btn banner-swiper-btn-prev" slot="button-prev"></div>
      <div class="banner-swiper-btn banner-swiper-btn-next" slot="button-next"></div>
    </swiper>

  </div>
</template>

<script>
  import bannerBg from '../image/banner_01.png';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import 'swiper/dist/css/swiper.css';
  import iconApi from '../image/ic_api.svg';
  import iconFlow from '../image/ic_flow.svg';
  import iconVisual from '../image/ic_visual.svg';
  import iconTxy from '../image/ic_tcloud2.svg';
  import iconWx from '../image/ic_wechat1.svg';
  import iconSg from '../image/digitalgd.png';
  // import config from '@_src/common/core/config';

  export default {
    name: 'banner',

    data () {
      return {
        img: bannerBg,
        swiperList: [
          {
            title: '互联网+政务',
            desc: '提供业界领先的政务服务解决方案',
            bg: require('../image/banner_01.png'),
            contentList: [
              {
                icon: iconApi,
                title: '能力聚合开放',
                desc: '提供众多政务服务支撑能力<br>覆盖大量政务服务场景',
              }, {
                icon: iconFlow,
                title: '服务快速交付',
                desc: '提供丰富的政务服务组件<br>助力政务服务产品快速落地',
              }, {
                icon: iconVisual,
                title: '全流程服务支撑',
                desc: '提供全生命周期的开发管理能力<br>实现项目与高效运转',
              }],
            btn: {
              title: '立即入驻',
            },
          }, {
            title: '数字化助手',
            desc: '政务服务开发者的连接器、工具箱，生态共建者',
            bg: require('../image/banner_02.png'),
            contentList: [
              {
                icon: iconWx,
                title: '微信',
                desc: '',
              }, {
                icon: iconTxy,
                title: '腾讯云',
                desc: '',
              }, {
                icon: iconSg,
                title: '公共支撑',
                desc: '',
              }],
            btn: {
              title: '了解更多',
            },
            href: `/doc`,
          }],
        swiperOption: {
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'banner-swiper-pagination-bullet',
            bulletActiveClass: 'banner-swiper-pagination-bullet-active',
          },
          navigation: {
            nextEl: '.banner-swiper-btn-next',
            prevEl: '.banner-swiper-btn-prev',
          },
        },
      };
    },

    components: {
      swiper,
      swiperSlide,
    },

    methods: {
      itemBgStyle (img) {
        return {
          backgroundImage: `url(${img})`,
        };
      },

      onClickBtn (item) {
        if (item && item.href) {
          window.location.href = item.href;
        }
        else {
          this.$toast.info('敬请期待');
        }
      },
    },
  };
</script>

<style lang="less" src="../styles/banner-swiper.less"></style>
